import {combineReducers} from 'redux'
import {createPivotTableReducer} from 'reducers/pivotTable'

export const partSupplierCostBreaksPivotTableKey = 'priceListsContext.part.partSupplierCostPriceBreaks.pivotTable'

export default combineReducers({
  pivotTable: createPivotTableReducer({key: partSupplierCostBreaksPivotTableKey, defaultSortColumn: 'id'}),
})
